import { render, staticRenderFns } from "./OneCard.vue?vue&type=template&id=9619df32&"
import script from "./OneCard.vue?vue&type=script&lang=js&"
export * from "./OneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports